import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: James Coyle
 * id 4B8AAB0C-9EB8-44D9-B1DF-C2EE6ACB91BE
 * name archive-outline
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-outline.svg
 * tags
 */
export const ArchiveOutlineIcon = createSvgIcon(<><path d="M20 21H4V10H6V19H18V10H20V21M3 3H21V9H3V3M9.5 11H14.5C14.78 11 15 11.22 15 11.5V13H9V11.5C9 11.22 9.22 11 9.5 11M5 5V7H19V5H5Z" /></>, 'ArchiveOutlineIcon');
export default ArchiveOutlineIcon